import { ICellRendererParams } from 'ag-grid-community';

import { Loader } from 'core/elements';
import { useAgGridCellUpdateContext } from 'core/states';
import { getAgGridTableCellData } from 'core/utils';
import { PartDescription } from 'quotes/components/PartDescription';
import { QuotePartColId } from 'quotes/components/QuotePartList';
import { Size } from 'theme/enums';

export const DescriptionCell = (props: ICellRendererParams) => {
  const { isUpdating } = useAgGridCellUpdateContext();

  const data = getAgGridTableCellData(props, QuotePartColId.DESCRIPTION);

  if (!data) {
    return props?.value;
  }

  if (isUpdating(props.node.id, QuotePartColId.DESCRIPTION)) {
    return <Loader size={Size.SM} style={{ textAlign: 'inherit', margin: 0, display: 'block' }} />;
  }

  return <PartDescription quotePart={data} />;
};
